import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Grid, Dropdown } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import Swal from 'sweetalert2'
import {
  GetSitesUnderCustomer as GetAssetsByType,
  AssignTemplateToAssets,
} from '../../services/asset'

const AssignToAssetModal = ({ open, setOpen, template, customerId }) => {
  const [options, setOptions] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [selectedAssets, setSelectedAssets] = useState([])
  useEffect(() => {
    ;(async () => {
      if (open) {
        console.log('tmep: ', template)
        const product = await localStorage.getItem('product')
        Swal.showLoading()
        const res = await GetAssetsByType(
          customerId,
          template.assetType,
          product,
        )
        Swal.close()
        setOptions(
          res.map((el) => ({
            key: el.id,
            text: el.label || el.name,
            value: el.id,
          })),
        )
      }
    })()
  }, [open])

  const submitHandler = async (e) => {
    e.preventDefault()
    const product = await localStorage.getItem('product')
    if (selectedAssets.length === 0) return
    const queryParams = { product }
    const body = selectedAssets.map((asset) => ({
      'template name': template['template name'],
      'asset thresholds': template.configurationTemplate,
      'customer id': customerId,
      'asset id': asset,
      'asset type': template.assetType,
      action: 'assign',
    }))

    Swal.showLoading()
    const res = await AssignTemplateToAssets(queryParams, body)
    if (res.success) {
      await Swal.fire({
        title: 'Template Assigned Successfully!',
        confirmButtonColor: 'Green',
        icon: 'success',
      })
      setOpen(false)
    } else {
      Swal.fire({
        title: 'Error Assigning Template!',
        confirmButtonColor: 'Red',
        icon: 'error',
      })
    }
  }

  const handleChange = (e, data) => {
    setSelectedAssets(data.value)
  }
  return (
    <>
      <Modal open={open}>
        <Modal.Header style={{ backgroundColor: '#4b6587', color: '#FFF' }}>
          Assign Template To Assets
        </Modal.Header>
        <Modal.Content>
          <Form
            style={{
              backgroundColor: 'rgb(216, 231, 234)',
              padding: 10,
              borderRadius: 9,
            }}
            onSubmit={submitHandler}
          >
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column>
                  <p>
                    <b>Template Name:</b> {template['template name']}
                  </p>
                </Grid.Column>

                <Grid.Column>
                  <p>
                    <b>Template Type:</b> {template.assetType}
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <hr />
            <br />

            <span>Select One Or More Assets</span>
            <Dropdown
              placeholder="Select Asset"
              fluid
              multiple
              search
              selection
              onChange={handleChange}
              options={options}
            />
            <hr />
            <Button
              type="submit"
              style={{ backgroundColor: '#5cb85c', color: '#FFF' }}
            >
              Save
            </Button>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

AssignToAssetModal.propTypes = {
  open: Proptypes.bool,
  template: Proptypes.object,
  setOpen: Proptypes.func,
  customerId: Proptypes.string,
}

export default AssignToAssetModal
